import { LogOut, User, Building2, Clock } from 'lucide-react';
import { useAuth } from '../../lib/auth';

export default function Header() {
  const { user, logout, idleRemainingSec } = useAuth();

  const idleMin = Math.floor(idleRemainingSec / 60);
  const idleSec = idleRemainingSec % 60;
  const idleColor = idleMin < 5 ? 'text-red-500' : idleMin < 15 ? 'text-amber-500' : 'text-gray-400';

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 lg:px-8 ml-0 lg:ml-64">
      <div className="flex items-center gap-3">
        {/* Spacer for mobile menu button */}
        <div className="w-10 lg:hidden" />
        <div>
          <h1 className="text-base font-semibold text-gray-900 lg:hidden">
            Datenplattform
          </h1>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {user && (
          <>
            <div className="hidden sm:flex sm:items-center sm:gap-3">
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Building2 size={16} />
                <span>{user.organization?.name ?? '—'}</span>
              </div>
              <div className="h-5 w-px bg-gray-200" />
            </div>

            {/* Idle-Countdown */}
            <div className={"flex items-center gap-1.5 text-xs tabular-nums " + idleColor}>
              <Clock size={14} />
              <span title="Automatischer Logout bei Inaktivität">{idleMin}:{idleSec.toString().padStart(2, '0')}</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100">
                <User size={18} className="text-primary" />
              </div>
              <div className="hidden sm:block">
                <p className="text-sm font-medium text-gray-900 leading-tight">
                  {[user.firstName, user.lastName].filter(Boolean).join(' ') || user.displayName}
                </p>
              </div>
            </div>

            <button
              onClick={logout}
              className="btn-ghost text-gray-400 hover:text-red-600"
              title="Abmelden"
              aria-label="Abmelden"
            >
              <LogOut size={20} />
            </button>
          </>
        )}
      </div>
    </header>
  );
}
